<script lang="ts" setup>
import { computed, defineProps } from 'vue'
import BKUserSelect from '@/components/BKUserSelect.vue'
import { Studio, StudioUser } from '@/modules/Studios/types'
import { addStudioAdmin, removeStudioAdmin } from '@/enitites/studio/api/endpoints'

const props = defineProps<{
  studio: Studio
}>()

const excludedUsersIds = computed(() => props.studio.admins.map((admin) => admin.id))

const addAdmin = async (user: StudioUser) => {
  const resp = await addStudioAdmin(props.studio.id, user.id)
  if (resp) props.studio.admins.push(user)
}

const removeAdmin = async (user: StudioUser) => {
  const resp = await removeStudioAdmin(props.studio.id, user.id)
  if (resp) {
    props.studio.admins = props.studio.admins.filter((admin) => admin.id !== user.id)
  }
}
</script>
<template>
  <div class="studio-admin">
    <p class="studio-admins-title">Add admins</p>
    <!--      eslint-disable vuejs-accessibility/aria-role-->
    <BKUserSelect
      :exclude="excludedUsersIds"
      :select-user-chip="studio.admins"
      label-text="Find admins to add"
      role="admin"
      @removeUser="removeAdmin"
      @selectUser="addAdmin"
    />
    <!--      eslint-enable vuejs-accessibility/aria-role-->
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/mixins';

.studio-admin {
  width: 100%;
  min-height: 500px;
}

.studio-admins-title {
  margin: 12px 0;
  color: var(--color-dark-800);
}
</style>
